import React, { useState } from "react";
import { api, extractError } from "../lib/api";
import { toast } from "sonner";

/** Docs that can be captured at loading / provisional (before goods receipt). */
export const DISPATCH_DOC_KINDS = [
  { value: "TRUCK_RC", label: "Truck RC" },
  { value: "OWNER_CHEQUE", label: "Owner cheque" },
  { value: "DRIVER_AADHAAR", label: "Driver Aadhaar" },
  { value: "OTHER", label: "Other" },
];

/**
 * Upload truck / driver docs for an outward dispatch.
 * Works before or after provisional voucher (API allows DISPATCH_DOC_KINDS early).
 */
export default function DispatchDocsUpload({
  dispatchId,
  docs = [],
  onUploaded,
  kinds = DISPATCH_DOC_KINDS,
  hint = "Optional — can also be uploaded later at settlement.",
}) {
  const [uploading, setUploading] = useState(null);

  const uploadDoc = async (kind, file) => {
    if (!file || !dispatchId) return;
    try {
      setUploading(kind);
      const fd = new FormData();
      fd.append("file", file);
      fd.append("kind", kind);
      const { data } = await api.post(`/outward-dispatches/${dispatchId}/settlement-docs`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`${kind.replace(/_/g, " ")} uploaded`);
      onUploaded?.(data.dispatch || data);
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setUploading(null);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        {kinds.map((dk) => (
          <label
            key={dk.value}
            className="inline-flex cursor-pointer items-center gap-1.5 rounded border border-border/70 px-2 py-1.5 text-xs hover:bg-muted/40"
          >
            <span>{dk.label}</span>
            <input
              type="file"
              accept="image/*,application/pdf"
              className="hidden"
              disabled={!!uploading}
              onChange={(e) => {
                const f = e.target.files?.[0];
                e.target.value = "";
                uploadDoc(dk.value, f);
              }}
            />
          </label>
        ))}
      </div>
      {uploading ? (
        <p className="text-[11px] text-muted-foreground">Uploading {uploading.replace(/_/g, " ")}…</p>
      ) : hint ? (
        <p className="text-[11px] text-muted-foreground">{hint}</p>
      ) : null}
      {docs.length > 0 ? (
        <ul className="text-xs text-muted-foreground space-y-0.5">
          {docs.map((doc, i) => (
            <li key={`${doc.uri || doc.kind}-${i}`}>
              {doc.kind}
              {doc.url ? (
                <>
                  {" · "}
                  <a href={doc.url} target="_blank" rel="noreferrer" className="text-primary underline">
                    view
                  </a>
                </>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
